export default __webpack_public_path__ + "static/do-mixi-ae78d6e0f1e89d40c4e544d53008521f.jpeg";